import React from 'react';
import 'react-grid-layout/css/styles.css';
import { Provider as ReduxProvider } from 'react-redux';
import 'react-resizable/css/styles.css';
import App from './App';
import { persistor, store } from './redux/store';
import { Amplify } from 'aws-amplify';
import awsExports from './aws-exports';
import { PersistGate } from 'redux-persist/integration/react';
import { createRoot } from 'react-dom/client';

import '@aws-amplify/ui-react/styles.css';
import './styles/main.css';

Amplify.configure(awsExports);

// Filter out specific React warnings and OSMD logs in development
if (import.meta.env.DEV) {
  const originalError = console.error;
  const originalLog = console.log;

  console.error = (...args: any) => {
    // Suppress the handleAxis warning coming from react-grid-layout
    for (const arg of args) {
      if (typeof arg === 'string' && arg.includes('handleAxis')) {
        return;
      }
    }
    originalError.apply(console, args);
  };

  console.log = (...args: any) => {
    for (const arg of args) {
      // Suppress OSMD timing source logs
      if (typeof arg === 'string' && arg.includes('linear timing source')) {
        return;
      }
    }
    originalLog.apply(console, args);
  };
}

if (import.meta.env.PROD) {
  console.log = () => {};
  console.error = () => {};
  console.debug = () => {};
}

const container = document.getElementById('root');
if (!container) throw new Error('Failed to find the root element');
const root = createRoot(container);

root.render(
  <React.StrictMode>
    <ReduxProvider store={store}>
      <PersistGate loading={null} persistor={persistor}>
        <App />
      </PersistGate>
    </ReduxProvider>
  </React.StrictMode>
);
